"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var semantic_ui_react_1 = require("semantic-ui-react");

var component_1 = require("..");

var helper_1 = require("../../helper");

exports.generateChartDataEntry = function (hoverinfo, color, name, subtitle, nodeSize, points, extra) {
  if (extra === void 0) {
    extra = {};
  }

  return __assign({
    hoverinfo: hoverinfo,
    marker: typeof color === 'string' ? {
      color: new Array(points.length * 2).fill(color)
    } : {
      colorscale: [[0, 'rgb(12,50,102)'], [0.1, 'rgb(17,83,150)'], [0.2, 'rgb(40,114,175)'], [0.3, 'rgb(71,147,193)'], [0.4, 'rgb(111,175,209)'], [0.5, 'rgb(160,202,222)'], [0.6, 'rgb(200,219,237)'], [0.7, 'rgb(224,235,246)'], [0.8, 'rgb(247,251,255)'], [0.9, 'rgb(249,253,255)'], [1, 'rgb(255,255,255)']]
    },
    mode: 'lines+markers',
    name: name,
    nodeSize: nodeSize,
    points: points,
    subtitle: subtitle
  }, extra);
};
/**
 * Intermediary between a ContactMap and a PlotlyChart.
 *
 * Will transform data and setup layout from science/chell data type into the Plotly type.
 * @extends {React.Component<IContactMapChartProps, any>}
 */


var ContactMapChart =
/** @class */
function (_super) {
  __extends(ContactMapChart, _super);

  function ContactMapChart(props) {
    var _this = _super.call(this, props) || this;

    _this.toggleLegendVisibility = function () {
      _this.setState({
        showlegend: !_this.state.showlegend
      });
    };

    _this.state = {
      numLegends: 0,
      plotlyData: [],
      showlegend: false
    };
    return _this;
  }

  ContactMapChart.prototype.componentDidMount = function () {
    this.setupData();
  };

  ContactMapChart.prototype.componentDidUpdate = function (prevProps) {
    var _a = this.props,
        contactData = _a.contactData,
        secondaryStructures = _a.secondaryStructures,
        selectedSecondaryStructures = _a.selectedSecondaryStructures;

    if (prevProps.contactData !== contactData || prevProps.secondaryStructures !== secondaryStructures || prevProps.selectedSecondaryStructures !== selectedSecondaryStructures) {
      this.setupData();
    }
  };

  ContactMapChart.prototype.render = function () {
    var _a = this.props,
        configurations = _a.configurations,
        contactData = _a.contactData,
        legendModifiers = _a.legendModifiers,
        marginModifiers = _a.marginModifiers,
        range = _a.range,
        showConfigurations = _a.showConfigurations,
        passThroughProps = __rest(_a, ["configurations", "contactData", "legendModifiers", "marginModifiers", "range", "showConfigurations"]);

    var _b = this.state,
        plotlyData = _b.plotlyData,
        showlegend = _b.showlegend;
    return React.createElement(component_1.SettingsPanel, {
      configurations: configurations,
      showConfigurations: showConfigurations
    }, React.createElement(semantic_ui_react_1.Button, {
      basic: true,
      floated: 'left',
      icon: React.createElement(semantic_ui_react_1.Icon, {
        name: 'question circle outline',
        size: 'large'
      }),
      onClick: this.toggleLegendVisibility,
      style: {
        float: 'left',
        margin: '0 0 0 15px',
        position: 'relative',
        top: '500px',
        zIndex: 999
      }
    }), React.createElement(component_1.PlotlyChart, __assign({
      data: plotlyData,
      layout: {
        legend: {
          orientation: 'h',
          y: legendModifiers.y,
          yanchor: 'bottom'
        },
        margin: {
          b: marginModifiers.b,
          l: marginModifiers.l
        },
        showlegend: showlegend,
        xaxis: {
          autorange: true,
          fixedrange: true,
          nticks: 10,
          range: [0, 33000],
          rangemode: 'nonnegative',
          showline: true,
          tickmode: 'auto',
          title: 'Residue #'
        },
        yaxis: {
          autorange: 'reversed',
          fixedrange: true,
          nticks: 10,
          range: [0, 33000],
          rangemode: 'nonnegative',
          showline: true,
          tickmode: 'auto',
          title: 'Residue #'
        }
      }
    }, passThroughProps)));
  };
  /**
   * Sets up the chart and axis data for the ContactMap.
   *
   * Transforms all data from chell terminology to data properly formatted for Plotly consumption.
   */


  ContactMapChart.prototype.setupData = function () {
    var _a = this.props,
        contactData = _a.contactData,
        dataTransformFn = _a.dataTransformFn,
        secondaryStructures = _a.secondaryStructures,
        selectedSecondaryStructures = _a.selectedSecondaryStructures;

    var plotlyData = __spread(contactData.map(function (entry) {
      return dataTransformFn(entry, true);
    }));

    secondaryStructures.forEach(function (secondaryStructure, index) {
      var axis = new component_1.SecondaryStructureAxis(secondaryStructure, 3, index + 2);
      plotlyData.push.apply(plotlyData, __spread(axis.xAxes, axis.yAxes));
    });
    var highlightedAxes = new Array();
    selectedSecondaryStructures.forEach(function (selectedStructure, index) {
      var axis = new component_1.AuxiliaryAxis(selectedStructure, index + 2, 'orange');
      highlightedAxes.push.apply(highlightedAxes, __spread(axis.highlightedXAxes, axis.highlightedYAxes));
    });
    this.setState({
      numLegends: new Set(plotlyData.filter(function (datum) {
        return datum.showlegend !== false && datum.name !== undefined;
      }).map(function (legend) {
        return legend.name;
      })).size,
      // Makes sure that highlighted axis is behind the axis.
      plotlyData: __spread(highlightedAxes, plotlyData)
    });
  };

  ContactMapChart.defaultProps = {
    candidateResidues: new Array(),
    configurations: new Array(),
    dataTransformFn: helper_1.generateScatterGLData,
    height: '100%',
    legendModifiers: {
      y: -0.4
    },
    marginModifiers: {
      b: 65,
      l: 65
    },
    range: 100,
    secondaryStructures: [],
    selectedSecondaryStructures: [],
    selectedSecondaryStructuresColor: '#feb83f',
    showConfigurations: true,
    width: '100%'
  };
  return ContactMapChart;
}(React.Component);

exports.ContactMapChart = ContactMapChart;